import curriculum001 from './curriculum_0.0.1.json';

const Curriculum = { '0.0.1': curriculum001 };

export default Curriculum;
